import { Flex, SegmentedControl } from "@mantine/core";
import type { JSX } from "react";
import { getRootDispatcher } from "@/analytics";
import classes from "./ChartHeader.module.css";

interface ChartHeaderProps {
    value: string;
    isOtherPlansEnabled: boolean;
    setValue: React.Dispatch<React.SetStateAction<string>>;
}

export function ChartHeader({ value, isOtherPlansEnabled, setValue }: ChartHeaderProps): JSX.Element {
    const onChangeTab = (value: string) => {
        setValue(value);
        void getRootDispatcher().dispatchBusinessEvent("PayDashViewToggled", {
            view: value,
        });
    };

    const data = [
        { label: "Sales", value: "Sales" },
        { label: "Surveys", value: "Surveys" },
    ];
    if (isOtherPlansEnabled) {
        data.push({ label: "Other plans", value: "Other" });
    }

    return (
        <Flex justify="space-between" align="center" pb="md" pt="xl">
            <SegmentedControl
                value={value}
                onChange={onChangeTab}
                color="asurion"
                w={375}
                fz="sm"
                data={data}
                classNames={{
                    root: classes.segmentedRoot,
                    control: classes.segmentedControl,
                    innerLabel: classes.label,
                }}
            />
        </Flex>
    );
}
